import { render, staticRenderFns } from "./DepartmentLimitRules.vue?vue&type=template&id=3e50a2c3"
import script from "./DepartmentLimitRules.vue?vue&type=script&lang=js"
export * from "./DepartmentLimitRules.vue?vue&type=script&lang=js"
import style0 from "./DepartmentLimitRules.vue?vue&type=style&index=0&id=3e50a2c3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports